import { Grid } from "@mui/material";
import { ProductCard } from "components/ui";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import useStockInCatalog from "hooks/useStockInCatalog";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { removeEditCategory, addToCart as addToCartAction, removeFromCart as removeFromCartAction } from "store/cartSlice";

const Product = ({ data, allData }) => {
  const location = useLocation();
  const innerChnages = location?.state?.innerChnages;
  const [btnName, setBtnName] = useState("Select");
  const { setBtnTitle, btnTitle, presentInCatalog } = useStockInCatalog(data);
  const { isEdit, setIsBtnEnable } = React.useContext(SortContext);
  const dispatch = useDispatch();

  const selectProd = React.useCallback(() => {
    setBtnName("Selected");
  }, [setBtnName]);

  const unSelect = React.useCallback(
    (productToRemove) => {
      setBtnName("Select");
      // let getUpdateCatagoryData = JSON.parse(sessionStorage.getItem("removedDesignsBySet")) || [];
      // getUpdateCatagoryData = getUpdateCatagoryData.filter((item) => (item.id || item._id) !== productToRemove.id);
      // sessionStorage.setItem("removedDesignsBySet", JSON.stringify(getUpdateCatagoryData));
      dispatch(
        removeEditCategory({
          storageKey: "removedDesignsBySet",
          id: productToRemove._id || productToRemove.id,
        })
      );
      window.dispatchEvent(new Event("UpdateSubCategory"));
      // setIsEditCatagoryData(JSON.parse(sessionStorage.getItem("RestrictDesign")) || []);
    },
    [dispatch, setBtnName]
  );

  const selectedCartProducts = React.useMemo(
    () => ({
      ...data,
      isAddedInCart: true,
    }),
    [data]
  );
  const handleAddToCartBtn = () => {
    setBtnTitle("Added");
    dispatch(addToCartAction({ product: selectedCartProducts, location }));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const handleRemoveCart = () => {
    setBtnTitle("Add");
    dispatch(removeFromCartAction(selectedCartProducts));
    sessionStorage.setItem("RecentlyRemoved", JSON.stringify(selectedCartProducts));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  return (
    <Grid key={data.id} item className="product">
      <ProductCard
        data={data}
        selectedCartProducts={selectedCartProducts}
        style={{ maxWidth: "474px", minWidth: "474px" }}
        {...(isEdit === "click" && {
          isBtn: true,
          btnTilte: btnName,
          addtoCart: selectProd,
          removeCart: unSelect,
          updateCatagoryData: "removedDesignsBySet",
        })}
        {...(innerChnages && {
          isBtn: innerChnages,
          btnTilte: btnTitle,
          addtoCart: handleAddToCartBtn,
          removeCart: handleRemoveCart,
        })}
        allData={allData}
      />
    </Grid>
  );
};

export default Product;
